import { render, staticRenderFns } from "./ModuleContainer.vue?vue&type=template&id=63a25521&scoped=true&"
import script from "./ModuleContainer.vue?vue&type=script&lang=js&"
export * from "./ModuleContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModuleContainer.vue?vue&type=style&index=0&id=63a25521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a25521",
  null
  
)

export default component.exports